import React from 'react';
import IconCard from '#/shared/components/IconCard';
import HopPhone from '#/shared/components/GeneratedIcons/trimet/HopPhone';
import HopCardTilted from '#/shared/components/GeneratedIcons/trimet/HopCardTilted';
import HopContactless from '#/shared/components/GeneratedIcons/trimet/HopContactless';
import HopCash from '#/shared/components/GeneratedIcons/trimet/HopCash';
import { HOP_PAGE_LINKS } from '#/shared/constants';
import useTriMetStaticPageLinks from '#/shared/hooks/useTriMetStaticPageLinks';
import * as Styled from './styled';

// TODO: Add Google Tag Manager

export default function PayList() {
  const { trimetLinks } = useTriMetStaticPageLinks();

  return (
    <Styled.PayListBody>
      <IconCard
        icon={<HopPhone />}
        titleId="pay.titlePhone"
        descriptionId="pay.descriptionPhone"
        linkTextId="pay.linkTextPhone"
        linkUrl={HOP_PAGE_LINKS.phone}
      />

      <IconCard
        icon={<HopCardTilted />}
        titleId="pay.titleHopCard"
        descriptionId="pay.descriptionHopCard"
        linkTextId="pay.linkTextHopCard"
        linkUrl={HOP_PAGE_LINKS.hopCard}
      />

      <IconCard
        icon={<HopContactless />}
        titleId="pay.titleContactless"
        descriptionId="pay.descriptionContactless"
        linkTextId="pay.linkTextContactless"
        linkUrl={HOP_PAGE_LINKS.contactless}
      />

      <IconCard
        icon={<HopCash />}
        titleId="pay.titleCash"
        descriptionId="pay.descriptionCash"
        linkTextId="pay.linkTextCash"
        linkUrl={trimetLinks.howToPayCash}
      />
    </Styled.PayListBody>
  );
}
